// W-0560 — Validação Yup local da página Reapresentação de Cheques Devolvidos.
// Fonte: TechSpec §3.4 + LICOES §1.6 / FE-002.
import * as Yup from 'yup';
import { MODO_NUMERO, MODO_CEDENTE, MODO_BANCO_AGENCIA } from './mensagens';

// Schema condicional do card de Busca — 3 modos exclusivos.
export const buscaChequesSchema = Yup.object().shape({
  modo: Yup.string()
    .oneOf([MODO_NUMERO, MODO_CEDENTE, MODO_BANCO_AGENCIA])
    .required('Selecione um modo de busca.'),
  numero_cheque: Yup.number()
    .typeError('Número do cheque deve ser numérico.')
    .when('modo', {
      is: MODO_NUMERO,
      then: Yup.number()
        .typeError('Número do cheque deve ser numérico.')
        .required('Número do cheque é obrigatório.')
        .positive('Número do cheque deve ser positivo.'),
      otherwise: Yup.number().nullable(),
    }),
  cedente: Yup.string().when('modo', {
    is: MODO_CEDENTE,
    then: Yup.string()
      .required('Cedente é obrigatório.')
      .min(3, 'Informe ao menos 3 caracteres.'),
    otherwise: Yup.string().nullable(),
  }),
  banco: Yup.number()
    .typeError('Banco deve ser numérico.')
    .when('modo', {
      is: MODO_BANCO_AGENCIA,
      then: Yup.number()
        .typeError('Banco deve ser numérico.')
        .required('Banco é obrigatório.')
        .positive('Banco deve ser positivo.'),
      otherwise: Yup.number().nullable(),
    }),
  agencia: Yup.number()
    .typeError('Agência deve ser numérica.')
    .when('modo', {
      is: MODO_BANCO_AGENCIA,
      then: Yup.number()
        .typeError('Agência deve ser numérica.')
        .required('Agência é obrigatória.')
        .positive('Agência deve ser positiva.'),
      otherwise: Yup.number().nullable(),
    }),
  conta_cedente: Yup.string().when('modo', {
    is: MODO_BANCO_AGENCIA,
    then: Yup.string().required('Conta do cedente é obrigatória.'),
    otherwise: Yup.string().nullable(),
  }),
  numero_cheque_bac: Yup.number()
    .typeError('Número do cheque deve ser numérico.')
    .when('modo', {
      is: MODO_BANCO_AGENCIA,
      then: Yup.number()
        .typeError('Número do cheque deve ser numérico.')
        .required('Número do cheque é obrigatório.')
        .positive('Número do cheque deve ser positivo.'),
      otherwise: Yup.number().nullable(),
    }),
});

// Schema por linha do carrinho.
export const chequeProcessamentoSchema = Yup.object().shape({
  codigo_titulo: Yup.number()
    .typeError('Código do título inválido.')
    .required()
    .positive(),
  conta_deposito: Yup.number()
    .typeError('A conta para depósito não pode conter valor nulo.')
    .required('A conta para depósito não pode conter valor nulo.')
    .positive('A conta para depósito não pode conter valor nulo.'),
  taxa_digitada: Yup.number()
    .typeError('Taxa inválida.')
    .required('Informe a taxa.')
    .min(0, 'Taxa não pode ser negativa.'),
  juros_digitado: Yup.number()
    .typeError('Juros inválidos.')
    .required()
    .min(0, 'Juros não podem ser negativos.'),
});

// Schema do lote completo (POST /processar).
export const processarChequesSchema = Yup.object().shape({
  codigo_grupo_empresa: Yup.number()
    .typeError('GE obrigatório.')
    .required('Escolha um grupo de empresa!')
    .positive('Escolha um grupo de empresa!'),
  cheques: Yup.array()
    .of(chequeProcessamentoSchema)
    .min(1, 'Adicione ao menos um cheque ao carrinho.')
    .max(500, 'Limite de 500 cheques por processamento. Divida em lotes menores.'),
});
